<span class="eas-loader" *ngIf="variant === 'regular'" role="alert" aria-live="assertive" [attr.aria-label]="'common.loading' | translate">
    <span>
      <i *ngFor="let i of [0, 1, 2, 3]" [style.backgroundColor]="color"> </i>
    </span>
  </span>
  <div *ngIf="variant === 'finger'" class="loading-indicator" [attr.brand]="brand" [attr.size]="size" aria-live="polite" aria-atomic="true" [attr.aria-label]="'common.loading' | translate">
    <div class="li-loader" aria-hidden="true" >
    </div>
  </div>
  